"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reselect_1 = require("reselect");
var MaxCountsFunctions_1 = require("../../maxCounts/functions/MaxCountsFunctions");
var ConnectToTablesQueryGql_1 = require("../../queries/ConnectToTablesQueryGql");
var ConnectToTablesTotalCountQueryGql_1 = require("../../queries/ConnectToTablesTotalCountQueryGql");
var PaginatedQueryWrapper_1 = require("../../wrappers/PaginatedQueryWrapper");
var ConnectToDialogFunctions_1 = require("../ConnectToDialogFunctions");
var ConnectToTablesDisplayGrid_1 = require("../DisplayGrids/ConnectToTablesDisplayGrid");
var ConnectToTablesQueryGrid = /** @class */ (function (_super) {
    __extends(ConnectToTablesQueryGrid, _super);
    function ConnectToTablesQueryGrid(props) {
        var _this = _super.call(this, props) || this;
        _this.memoizedMapTableRowWithAllowedClasses = reselect_1.defaultMemoize(mapTableRowWithAllowedClasses(_this.props.allowedClasses));
        _this.state = { rowCount: 1 };
        return _this;
    }
    ConnectToTablesQueryGrid.prototype.render = function () {
        var _this = this;
        return (React.createElement(PaginatedQueryWrapper_1.PaginatedQueryWrapper, { queryGql: ConnectToTablesQueryGql_1.ConnectToTablesQueryGql, partialQueryVariables: { tableFilterText: this.props.searchText, orderBy: this.props.orderBy }, selectConnectionListResult: selectConnectionListResult, mapResultNode: this.memoizedMapTableRowWithAllowedClasses }, function (_a) {
            var rowStore = _a.rowStore;
            return (React.createElement(ConnectToTablesDisplayGrid_1.ConnectToTablesDisplayGrid, { hasFilter: _this.props.searchText !== '', orderBy: _this.props.orderBy, rowCount: _this.state.rowCount, rowStore: rowStore, selectedKeys: _this.props.selectedKeys, updateSelectionForKey: _this.props.updateSelectionForKey, updateSortOrder: _this.props.updateSortOrder }));
        }));
    };
    ConnectToTablesQueryGrid.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.searchText !== this.props.searchText
            || prevProps.orderBy.field !== this.props.orderBy.field
            || prevProps.orderBy.direction !== this.props.orderBy.direction) {
            this.updateCount();
        }
    };
    ConnectToTablesQueryGrid.prototype.componentDidMount = function () {
        this.updateCount();
    };
    ConnectToTablesQueryGrid.prototype.updateCount = function () {
        var _this = this;
        this.props.apolloClient.query({
            query: ConnectToTablesTotalCountQueryGql_1.ConnectToTablesTotalCountQueryGql,
            variables: { tableFilterText: this.props.searchText }
        }).then(function (result) {
            var newCount = result.data.databaseTablesConnection.totalCount;
            if (newCount !== _this.state.rowCount) {
                _this.setState({ rowCount: newCount });
                _this.props.updateRowsCallback(newCount);
            }
        }).catch(function () { return _this.setState({ rowCount: 0 }); });
    };
    return ConnectToTablesQueryGrid;
}(React.Component));
exports.ConnectToTablesQueryGrid = ConnectToTablesQueryGrid;
function selectConnectionListResult(resultData) {
    return resultData && resultData.databaseTablesConnection;
}
function mapTableRowWithAllowedClasses(allowedClasses) {
    return function mapTableRow(row, resultData) {
        var connectionType = row.database ? row.database.connectionType : null;
        return {
            connectionType: connectionType,
            contact: row.contact ? row.contact.username : null,
            database: row.__typename === 'DatabaseTable' ? row.database : null,
            dataQualityWarning: row.dataQualityWarning,
            datasourceConnectionCount: row.downstreamDatasourcesConnection != null ? row.downstreamDatasourcesConnection.totalCount : 0,
            datasourceMaxCount: MaxCountsFunctions_1.getMaxDownstreamDatasources(resultData),
            id: row.id,
            isCertified: !!row.isCertified,
            isSupported: ConnectToDialogFunctions_1.isRowEnabledForTableOrDatabase(connectionType, allowedClasses),
            name: row.name,
            workbookConnectionCount: row.downstreamWorkbooksConnection != null ? row.downstreamWorkbooksConnection.totalCount : 0,
            workbookMaxCount: MaxCountsFunctions_1.getMaxDownstreamWorkbooks(resultData),
        };
    };
}
//# sourceMappingURL=ConnectToTablesQueryGrid.js.map